import { render, staticRenderFns } from "./MenuSelect.vue?vue&type=template&id=aca22e6e&scoped=true"
import script from "./MenuSelect.vue?vue&type=script&lang=js"
export * from "./MenuSelect.vue?vue&type=script&lang=js"
import style0 from "./MenuSelect.vue?vue&type=style&index=0&id=aca22e6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca22e6e",
  null
  
)

export default component.exports